import { TdsNextLink } from '@/components/Link/TdsLink';
import { type SerializedAutoLinkNode, type SerializedLinkNode } from '@payloadcms/richtext-lexical';
import { type JSXConverters } from '@payloadcms/richtext-lexical/react';
export const LinkJSXConverter: (args: {
  internalDocToHref?: (args: {
    linkNode: SerializedLinkNode;
  }) => string;
  light?: boolean;
}) => JSXConverters<SerializedAutoLinkNode | SerializedLinkNode> = ({
  internalDocToHref,
  light
}) => ({
  link: ({
    node,
    nodesToJSX
  }) => {
    const children = nodesToJSX({
      nodes: node.children
    });
    try {
      let href: string = node.fields.url ?? '';
      if (node.fields.linkType === 'internal') {
        if (internalDocToHref) {
          href = internalDocToHref({
            linkNode: node
          });
        } else {
          console.error('Lexical => JSX converter: Link converter: found internal link, but internalDocToHref is not provided');
          href = ''; // fallback
        }
      }
      if (!href) {
        return children;
      }
      return <TdsNextLink className="break-all" light={light} external={node.fields.newTab} href={href}>
          {children}
        </TdsNextLink>;
    } catch (e) {
      console.error(e instanceof Error ? e.message : e);
      return children;
    }
  },
  autolink: ({
    node,
    nodesToJSX
  }) => {
    const children = nodesToJSX({
      nodes: node.children
    });
    try {
      const href: string = node.fields.url ?? '';
      if (!href) {
        return children;
      }

      // Autolinks (pasted URLs) default to opening in new tab
      const openInNewTab = node.fields.newTab ?? true;
      return <TdsNextLink className="break-all" light={light} external={openInNewTab} href={href}>
          {children}
        </TdsNextLink>;
    } catch (e) {
      console.error(e instanceof Error ? e.message : e);
      return children;
    }
  }
});